export function startTokenExpiryWatcher(getToken, onExpire, intervalMs = 5000) {
  const isJwtExpired = (token) => {
    if (!token) return true;
    try {
      const parts = token.split('.');
      if (parts.length < 2) return false;
      const payload = JSON.parse(atob(parts[1].replace(/-/g, '+').replace(/_/g, '/')));
      if (!payload.exp) return false;
      return payload.exp * 1000 < Date.now();
    } catch (e) {
      return false;
    }
  };

  const checkToken = () => {
    try {
      const token = getToken && getToken();
      if (token && isJwtExpired(token)) {
        onExpire && onExpire();
      }
    } catch (e) {
      console.error('Error checking token expiry:', e);
    }
  };

  checkToken();
  const id = setInterval(checkToken, intervalMs);

  const onVisibility = () => {
    if (document.visibilityState === 'visible') checkToken();
  };

  document.addEventListener('visibilitychange', onVisibility);

  return () => {
    clearInterval(id);
    document.removeEventListener('visibilitychange', onVisibility);
  };
}
